import { GET_CLAIMS_FAILED, GET_CLAIMS_START, GET_CLAIMS_SUCCESS, SET_USER, UserProfileStore } from './types';
import decode from 'jwt-decode';

export const userProfile = (
  state: UserProfileStore = {},
  action: {
    type: string;
    payload?: Partial<UserProfileStore>;
  }
): UserProfileStore => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        ...action.payload
      };
    case GET_CLAIMS_START:
      return {
        ...state,
        ...action.payload,
        loadingClaims: true,
        error: undefined
      };
    case GET_CLAIMS_SUCCESS: {
      const { claims, user } = action.payload;
      const { profileCode, organizationCode } = user;
      return {
        ...state,
        loadingClaims: false,
        error: undefined,
        claims,
        profileCode,
        orgCode: organizationCode,
        ...action.payload
      };
    }
    case GET_CLAIMS_FAILED: {
      return {
        ...state,
        loadingClaims: false,
        error: action.payload
      };
    }
    default:
      return state;
  }
};
